<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter" query-api="findTreeByFilter"
                           @emFilterQueried="handleQueried"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!--      useCheckColumn usePreColumn useRealTime default-expand-all-->
      <!--          :row-style="{height: '0'}"-->
      <!--          :cell-style="{padding: '0'}"-->
      <wlGantt :data="scheduledResult.ppdTree" :props="ganttConfig" :startDate="scheduledResult.fromDate" :endDate="scheduledResult.toDate"
               :default-expand-all="isExpandAll" :row-class-name="tableRowClassName" class="el-table"
               :edit="false" max-height="1000" :row-style="()=>{return {height: '0'}}"
               highlight-current-row @current-change="handleCurrentChange"
               :cell-style="()=>{return {padding: '0'}}">
        <el-table-column
            label="层级"
            prop="ppdActivityId"
            show-overflow-tooltip
            fixed
        >
        </el-table-column>
        <el-table-column fixed
                         label="进度"
                         prop="process"
        >
          <template slot-scope="scope">
            <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.process"></el-progress>
          </template>
        </el-table-column>
        <el-table-column
            label="状态"
            prop="status"
        ></el-table-column>
        <el-table-column
            label="duration"
            prop="ppdDuration"
        >
        </el-table-column>
        <el-table-column
            label="buffer"
            prop="ppdBufferTime"
        >
        </el-table-column>
        <el-table-column
            label="五大支柱编码"
            prop="ppdMilestoneCode"
        >
        </el-table-column>
        <!--        <el-table-column-->
        <!--          align="right">-->
        <!--        <template slot="header" slot-scope="scope">-->
        <!--          <el-input-->
        <!--              v-model="search"-->
        <!--              size="mini"-->
        <!--              placeholder="输入关键字搜索"/>-->
        <!--        </template>-->
        <!--        <template slot-scope="scope">-->
        <!--          <el-button-->
        <!--              size="mini"-->
        <!--              @click="handleEdit(scope.$index, scope.row)">Edit</el-button>-->
        <!--          <el-button-->
        <!--              size="mini"-->
        <!--              type="danger"-->
        <!--              @click="handleDelete(scope.$index, scope.row)">Delete</el-button>-->
        <!--        </template>-->
        <!--      </el-table-column>-->
      </wlGantt>
      <em-modal-entity-selector ref="emModalEntitySelector"/>
    </section>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-07-02 15:49:35

import emCommonListMixin from "@/mixin/em/common/list";

export default {
  name: "ppdGantt",
  mixins: [emCommonListMixin],
  data() {
    return {
      scheduledResult: [],
      isExpandAll: true,
      ganttConfig: {
        name: "ppdChineseDescription",
        pid: "parentId",
        startDate: "ppdOmForecastStartTime",
        endDate: "ppdOmForecastEndTime"
      },
    }
  },
  computed: {
    modelName() {
      return "sithMesPrdProjectPlanDetailPpd"
    },
    ganttData() {
      return this.$store.state[this.modelName].rows
    }
  },
  methods: {
    handleQueried(response) {
      this.scheduledResult = JSON.parse(JSON.stringify(response.data))
    },
    tableRowClassName({row, rowIndex}) {
      if (row.startDate === "2021-06-09") {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      // 20SP-V-000XXX.POC.01.952.952B
      // 20SP-V-000XXX.POC.01.951.951B
      return 'success-row';
    },
    handleCurrentChange(currentRow, oldCurrentRow) {
      console.log(currentRow.id)
    }
  }
}
</script>

<style scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: yellow;
}
</style>